import _ from 'lodash';
import * as ActionType from '../actions/actionType';

const initialState = {
  wishlist: []
};

const handleWishlistToLocalStorage = id => {
  let wishlist = window.localStorage.getItem('wishlist') || [];
  if (!_.isEmpty(wishlist)) {
    wishlist = JSON.parse(wishlist);
  }
  if (_.includes(wishlist, id)) {
    wishlist = _.without(wishlist, id);
  } else {
    wishlist.push(id);
  }
  window.localStorage.setItem('wishlist', JSON.stringify(wishlist));
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionType.RECEIVE_WISHLIST:
      return {
        ...state,
        wishlist: action.data
      };
    case ActionType.ADD_WISHLIST:
      handleWishlistToLocalStorage(action.id);
      return {
        ...state,
        wishlist: [...state.wishlist, action.id]
      };
    case ActionType.REMOVE_WISHLIST:
      handleWishlistToLocalStorage(action.id);
      return {
        ...state,
        wishlist: _.without(state.wishlist, action.id)
      };
    case ActionType.CLEAR_WISHLIST:
      window.localStorage.removeItem('wishlist');
      return {
        ...state,
        wishlist: []
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/quotes.js